var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('font-awesome-icon',{staticClass:"text-red-500",attrs:{"icon":['far', _vm.icon],"size":"xs"}}),_c('router-link',{staticClass:"ml-2 text-red-500 ",attrs:{"to":_vm.to}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }